import { useTranslations } from 'next-intl';

// 统一的 StoryboardItem 类型定义
export type StoryboardItem = {
  id: string;
  part: number;
  stage: string;
  duration: number;
  description: string;
  reference_subject_id: string[];
  reference_image_id: string[];
};

// 格式化后的 Script 数据类型
export type FormattedScriptData = {
  full_narration: string;
  storyboard: StoryboardItem[];
  copy_text: string;
  duration: number;
};

export const useFormattedScriptData = () => {
  const t = useTranslations();

  const cleanDescription = (description: string, referenceSubjectIds: string[] = []): string => {
    let cleanedDescription = description;
    if (referenceSubjectIds && Array.isArray(referenceSubjectIds)) {
      referenceSubjectIds.forEach((subjectId: string) => {
        const escapedSubjectId = subjectId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // 删除 ()、（）、[]、【】包裹的内容
        const regexFullWidth = new RegExp(`[（(【\\[][^）)】\\]]*${escapedSubjectId}[^）)】\\]]*[）)】\\]]`, 'g');
        cleanedDescription = cleanedDescription.replace(regexFullWidth, '');
      });
    }
    return cleanedDescription.trim();
  };

  const formatScript = (script: string): FormattedScriptData => {
    const scriptData = JSON.parse(script || '{}');
    let duration = 0;
    const full_narration: string = scriptData.full_narration || '';
    const storyboard: StoryboardItem[] = (scriptData.storyboard || []).map((item: StoryboardItem, index: number) => {
      const descriptionText = cleanDescription(item.description, item.reference_subject_id);
      const parts = descriptionText
        .split('【')
        .filter((part) => part.trim())
        .map((part) => `【${part.trim()}`)
        .join('\n');
      duration += item.duration;

      return {
        id: item.id,
        part: index + 1,
        stage: `${t('agentProject.scriptNode.shot', { number: index + 1 })}`,
        duration: item.duration,
        description: parts,
        reference_subject_id: item.reference_subject_id,
        reference_image_id: item.reference_image_id,
      };
    });

    const full_narration_text = `${t('agentProject.scriptNode.aside')}: ${full_narration}\n`;
    const storyboard_text = `${storyboard?.map((item: StoryboardItem, index: number) => `${t('agentProject.scriptNode.shot', { number: index + 1 })}:\n${item.description}`).join('\n')}`;
    const copy_text = `${full_narration_text} ${storyboard_text}`;

    return {
      full_narration,
      storyboard,
      copy_text,
      duration,
    };
  };

  return {
    formatScript,
  };
};
